export const getEnvironment = () => import.meta.env.MODE;

export const isDevelopment =
  import.meta.env.DEV || import.meta.env.VITE_CI === "true";

export const isNotProduction = () =>
  (getEnvironment() !== "production" &&
    getEnvironment() !== "production-deployment") ||
  import.meta.env.VITE_CI === "true";
